export default __webpack_public_path__ + "static/media/Scientists_Row-1.1abb94a8.png";